import apiService from './ApiService';

// Servicio para endpoints de Regionales, Materias y asignaciones
class RegionalApiService {
  async getRegionales() {
    return apiService.get('/regionales');
  }

  async getRegionalesActivos() {
    return apiService.get('/regionales/activos');
  }

  async getMisRegionales() {
    return apiService.get('/regionales/mis');
  }

  async getRegionalById(id) {
    return apiService.get(`/regionales/${id}`);
  }

  async getRegionalByIdAdmin(id) {
    return apiService.get(`/regionales/${id}/admin`);
  }

  async getFeatureFlagsByRegional(id) {
    return apiService.get(`/regionales/${id}/feature-flags`);
  }

  async updateFeatureFlagByRegional(id, nombre, activo) {
    return apiService.put(`/regionales/${id}/feature-flags/${encodeURIComponent(nombre)}`, { activo });
  }

  async getConsumosByRegional(id) {
    return apiService.get(`/regionales/${id}/consumos`);
  }

  async getRegionalByNombreUrl(nombreUrl) {
    return apiService.getPublic(`/regionales/por-nombre-url/${encodeURIComponent(nombreUrl)}`);
  }

  async createRegional(payload) {
    return apiService.post('/regionales', payload);
  }

  async updateRegional(id, payload) {
    return apiService.put(`/regionales/${id}`, payload);
  }

  async updateRegionalActivo(id, activo) {
    return apiService.put(`/regionales/${id}/activo`, { activo });
  }

  async deleteRegional(id) {
    return apiService.delete(`/regionales/${id}`);
  }

  async getMaterias() {
    return apiService.get('/Materias');
  }

  async createMateria(payload) {
    return apiService.post('/Materias', payload);
  }

  async updateMateria(id, payload) {
    return apiService.put(`/Materias/${id}`, payload);
  }

  async deleteMateria(id) {
    return apiService.delete(`/Materias/${id}`);
  }

  async assignUserToRegional(regionalId, payload) {
    return apiService.post(`/Regional/${regionalId}/usuarios`, payload);
  }

  async assignUserToArea(areaId, payload) {
    return apiService.post(`/Area/${areaId}/usuarios`, payload);
  }
}

const regionalApiService = new RegionalApiService();

export default regionalApiService;
